import { render } from "./HelpWrapper.vue?vue&type=template&id=1fbc2398"
import script from "./HelpWrapper.vue?vue&type=script&lang=js"
export * from "./HelpWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/help/HelpWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fbc2398"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fbc2398', __exports__)) {
    api.reload('1fbc2398', __exports__)
  }
  
  module.hot.accept("./HelpWrapper.vue?vue&type=template&id=1fbc2398", () => {
    api.rerender('1fbc2398', render)
  })

}


export default __exports__